enum GearType {
  Manual = 'manual',
  Automatic = 'automatic',
}

export default GearType;
